export default __webpack_public_path__ + "static/media/archive_primary.852595b3.svg";